import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || null,

    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте\\nвариант ответа'
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    sizeQR: searchParams.get('sizeQR') || '23',
    paddingQR: searchParams.get('paddingQR') || '0',
    titleFontSize: searchParams.get('titleFontSize') || '4.4',
    questionFontSize: searchParams.get('questionFontSize') || '4.375',
    answerFontSize: searchParams.get('answerFontSize') || '4.06',
    varNumFontSize: searchParams.get('varNumFontSize') || '3.125',

    qrTitle2: searchParams.get('qrTitle2'),
    qrTitle1: searchParams.get('qrTitle1'),
    phoneNumber,
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    socials: searchParams.get('socials'),
  };
};
